export default "__VITE_PUBLIC_ASSET__fb4dee8a__"